/*! Cling Fishing product slider
 * A row of product cards that scrolls sideways: round arrow buttons step through on desktop, and the row
 * swipes on phones (CSS scroll snapping does the swiping, so it feels native). Arrows hide at either end.
 */
(function (global) {
  'use strict';
  function init(slider) {
    if (slider.__cling) return;
    slider.__cling = true;
    const track = slider.querySelector('[data-ccp-track]');
    const prev = slider.querySelector('[data-ccp-prev]'), next = slider.querySelector('[data-ccp-next]');
    if (!track) return;
    const reduce = global.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    // one "page" = the cards currently in view
    const step = () => {
      const card = track.querySelector('li');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const per = Math.max(1, Math.floor((track.clientWidth + gap) / (card.getBoundingClientRect().width + gap)));
      return per * (card.getBoundingClientRect().width + gap);
    };
    const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
      slider.classList.toggle('is-scrollable', max > 0);
    };
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    if (global.ResizeObserver) new ResizeObserver(update).observe(track); else global.addEventListener('resize', update);
    update();
  }
  function initAll(root) {
    (root || document).querySelectorAll('[data-ccp-slider]').forEach(init);
    (root || document).querySelectorAll('[data-ccp-hero]').forEach(initHero);
  }

  /* Banner video: silent and looping. Plays only while on screen; no autoplay for reduced motion or data
     saver (the still frame shows, and the button plays it); the phone version is used on small screens. */
  function initHero(hero) {
    if (hero.__cling) return;
    hero.__cling = true;
    const vids = [...hero.querySelectorAll('.ccp-hero-video, video')].filter((v, i, a) => a.indexOf(v) === i);
    if (!vids.length) return;
    const btn = hero.querySelector('[data-ccp-hero-toggle]');
    const small = global.matchMedia ? matchMedia('(max-width: 760px)') : null;
    const reduce = global.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    let userPaused = reduce || saveData, visible = false;
    vids.forEach((v) => { v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true; v.removeAttribute('controls'); });
    const active = () => {
      const mob = hero.querySelector('.ccp-hero-mobile video');
      return mob && small && small.matches ? mob : (hero.querySelector('.ccp-hero-desktop video') || vids[0]);
    };
    const sync = () => {
      const a = active();
      vids.forEach((v) => { if (v !== a && !v.paused) v.pause(); });
      if (!userPaused && visible) { if (a.preload === 'none') a.preload = 'auto'; const p = a.play(); if (p && p.catch) p.catch(() => {}); }
      else if (!a.paused) a.pause();
      if (btn) {
        const playing = !userPaused;
        btn.setAttribute('aria-pressed', String(!playing));
        btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        hero.classList.toggle('is-paused', !playing);
      }
    };
    if (btn) btn.addEventListener('click', () => { userPaused = !userPaused; sync(); });
    if (global.IntersectionObserver) {
      // "on screen" = at least a quarter of it showing
      new IntersectionObserver((es) => { visible = es.some((e) => e.intersectionRatio >= 0.25); sync(); }, { threshold: [0, 0.25, 0.5] }).observe(hero);
    } else { visible = true; }
    if (small && small.addEventListener) small.addEventListener('change', sync);
    document.addEventListener('visibilitychange', () => { if (document.hidden) vids.forEach((v) => v.pause()); else sync(); });
    sync();
  }
  global.ClingSlider = { init, initAll, initHero };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
})(window);
